const actionTypeIdentifier = '7942B7BA-767A-4404-A7A8-AE91ED35DCC3';

export const getOrderDetailsComments = `ORDERS-GET-ORDER-DETAILS-COMMENTS${actionTypeIdentifier}`;
export const getQuotationDetailsComments = `ORDERS-GET-QUOTATION-DETAILS-COMMENTS${actionTypeIdentifier}`;
export const setOrderDetailsError = `ORDERS-SET-ORDER-DETAILS-ERROR${actionTypeIdentifier}`;
export const insertOrderCircuitComments = `INSERT-ORDER-CIRCUIT-COMMENTS-${actionTypeIdentifier}`;
export const resetOrderCircuitComments = `RESET-ORDER-CIRCUIT-COMMENTS-${actionTypeIdentifier}`;
export const insertQuotationCircuitComments = `INSERT-QUOTATION-CIRCUIT-COMMENTS-${actionTypeIdentifier}`;
export const resetQuotationCircuitComments = `RESET-QUOTATION-CIRCUIT-COMMENTS-${actionTypeIdentifier}`;

